import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'orderBy', })
export class OrderByPipe implements PipeTransform {
  protected _compare(a: any, b: any) {
    if (isFinite(a) || isFinite(b)) { // Compares booleans, numbers, dates and empty arrays
      return a - b
    } else  { // Compares strings and any other object
      return String(a).localeCompare(String(b))
    }
  }

  protected _compareProperty(property, reverse) {
    if (reverse) {
      return (a, b) =>
        a[property] !== undefined && b[property] !== undefined ?
          this._compare(b[property], a[property]) :
          this._compare(b, a)
    } else {
      return (a, b) =>
        a[property] !== undefined && b[property] !== undefined ?
          this._compare(a[property], b[property]) :
          this._compare(a, b)
    }
  }

  protected _sort(value: any[], property: string | ((a, b) => number) = '+') {
    let sorted
    if (typeof property === 'function') {
      sorted = value.sort(property)
    } else {
      const order = property[0] // Get order direction
      if (order === '+' || order === '-') { property = property.substr(1) } // Remove order direction from property
      sorted = value.sort(
        property === '' ? this._compare : this._compareProperty(property, order === '-')
      )
    }
    return sorted
  }

  transform(value: any[], properties: any = '+') {
    if (value && (value instanceof Array)) { // Only sort arrays
      if (properties instanceof Array) {
        return properties.reduce((sorted, property) => this._sort(sorted, property) , value)
      } else {
        return this._sort(value, properties)
      }
    } else {
      return false
    }
  }
}
